<template>
  <v-sheet width="520" class="px-16 pt-8 pb-6">
    <p class="mb-6 font-weight-bold text-center text-h5">지점 추가</p>

    <v-form ref="form" lazy-validation>
      <v-sheet class="mt-2 px-4">
        <v-text-field class="rounded-lg mb-4" label="지점 코드" dense outlined v-model="form.branchCode" maxlength="20" required></v-text-field>
        <v-text-field class="rounded-lg mb-4" label="지점명" dense outlined v-model="form.name" maxlength="100" required></v-text-field>
        <v-select
          class="rounded-lg mb-4"
          label="상태"
          dense
          outlined
          :items="statusOptions"
          v-model="form.status"
        ></v-select>
        <v-select
          class="rounded-lg mb-4"
          label="운영 상품"
          dense
          outlined
          multiple
          chips
          :items="productOptions"
          v-model="form.availableProducts"
        ></v-select>
        <v-textarea class="rounded-lg" label="설명" dense outlined rows="3" auto-grow v-model="form.description"></v-textarea>
      </v-sheet>
    </v-form>

    <div class="d-flex justify-center mt-8">
      <v-btn width="100" color="grey lighten-3" depressed class="font-weight-bold rounded-10 mr-3" @click="close">닫기</v-btn>
      <v-btn width="100" dark depressed class="font-weight-bold rounded-10" @click="submit">입력</v-btn>
    </div>
  </v-sheet>
</template>

<script>
export default {
  data: () => ({
    statusOptions: [
      { text: "운영 (ACTIVE)", value: "ACTIVE" },
      { text: "비활성 (INACTIVE)", value: "INACTIVE" },
    ],
    productOptions: [
      { text: "메이커샷", value: "makershot" },
      { text: "프리미엄", value: "premium" },
    ],
    form: {
      branchCode: "",
      name: "",
      description: "",
      status: "ACTIVE",
      availableProducts: [],
    },
  }),
  methods: {
    resetForm() {
      this.form = {
        branchCode: "",
        name: "",
        description: "",
        status: "ACTIVE",
        availableProducts: [],
      }
    },
    close() {
      this.resetForm()
      this.$emit("close")
    },
    async submit() {
      if (!this.form.branchCode) {
        alert("지점 코드를 입력해주세요.")
        return
      }
      if (!this.form.name) {
        alert("지점명을 입력해주세요.")
        return
      }
      if (this.form.availableProducts.length === 0) {
        alert("운영 상품을 최소 1개 이상 선택해주세요.")
        return
      }

      try {
        await this.$http.post("/api/admin/branch", this.form)
        alert("지점이 정상적으로 등록되었습니다.")
        this.resetForm()
        this.$emit("inserted")
      } catch (error) {
        console.error("branch insert error", error)
        alert(error?.response?.data?.message || "지점을 등록하는 중 오류가 발생했습니다.")
      }
    },
  },
}
</script>
